module.exports = __webpack_public_path__ + "static/img/index-green.7f7bfc5.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/index-green.gif
// module id = Ghpq
// module chunks = 1